"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatomoTracker = void 0;
var qs = __importStar(require("querystring"));
var log_1 = __importDefault(require("@app/shared/log"));
var sha1_1 = require("@app/shared/sha1");
var MatomoTracker = /** @class */ (function () {
    function MatomoTracker() {
        // Matomo Server variables
        this.siteId = -1;
        this.trackerHost = '';
        // Matomo variables
        this.blastUrl = '';
        this.browserFeatures = {};
        this.cookiesDisabled = false;
        this.expireDateTime = -1;
        this.debug = false;
        this.initialized = false;
        this.timeNextTrackingRequestCanBeExecutedImmediately = -1;
        this.trackQ = [];
        this.user = '';
        // Cookie variables
        this.configCookieNamePrefix = '_pk_'; // First-party cookie name prefix
        this.domainHash = '';
        if (typeof navigator !== 'undefined') {
            this.navigatorAlias = navigator;
            this.screenAlias = screen;
            this.windowAlias = window;
            this.documentAlias = document;
            this.encodeWrapper = this.windowAlias.encodeURIComponent;
            this.decodeWrapper = this.windowAlias.decodeURIComponent;
            if (window.matomo) {
                // Matomo instance already exists
                return window.matomo;
            }
        }
    }
    MatomoTracker.prototype.initialize = function (siteId, trackerHost) {
        if (typeof navigator !== 'undefined') {
            this.siteId = siteId;
            this.trackerHost = trackerHost + '/piwik.php';
            this.initialized = true;
            this.blastUrl = window.location.origin;
            this.browserFeatures = this.detectBrowserFeatures();
            // setup agent with tracker url and install on global window.
            window.matomo = this;
        }
    };
    MatomoTracker.prototype.deinitialize = function () {
        if (typeof navigator !== 'undefined') {
            this.siteId = -1;
            this.initialized = false;
            // setup agent with tracker url and install on global window.
            window.matomo = this;
        }
    };
    MatomoTracker.prototype.getSiteId = function () {
        return this.siteId;
    };
    MatomoTracker.prototype.setUser = function (userId) {
        this.user = userId;
    };
    MatomoTracker.prototype.disableCookies = function () {
        this.cookiesDisabled = true;
    };
    MatomoTracker.prototype.enableDebug = function () {
        this.debug = true;
    };
    MatomoTracker.prototype.trackPageView = function (customUrl) {
        if (typeof navigator !== 'undefined') {
            this.trackBroker({ url: (customUrl) ? "" + this.blastUrl + customUrl : '' });
        }
    };
    MatomoTracker.prototype.trackEvent = function (category, action, name, value) {
        if (typeof navigator !== 'undefined') {
            // Autodetect window location to make this easier.
            this.trackBroker({ e_c: category, e_a: action, e_n: name, e_v: value });
        }
    };
    MatomoTracker.prototype.trackSearch = function (keyword, category, resultsCount) {
        if (typeof navigator !== 'undefined') {
            // Autodetect window location to make this easier.
            this.trackBroker({ search: keyword, search_cat: category, search_count: resultsCount });
        }
    };
    MatomoTracker.prototype.getLocation = function () {
        return window.location.href.split('?')[0];
    };
    MatomoTracker.prototype.trackBroker = function (options) {
        var _this = this;
        if (typeof navigator !== 'undefined') {
            this.makeSureThereIsAGapAfterFirstTrackingRequestToPreventMultipleVisitorCreation(function () {
                void _this.track(options);
            });
        }
    };
    MatomoTracker.prototype.createRequest = function (options) {
        if (typeof navigator !== 'undefined') {
            options = options || { url: this.getLocation() };
            options.idsite = this.siteId;
            options.rec = 1;
            var now = new Date();
            options.h = now.getUTCHours();
            options.m = now.getUTCMinutes();
            options.s = now.getUTCSeconds();
            // If no url specified get default.
            if (!options.url) {
                options.url = this.getLocation();
            }
            // optional globals
            if (this.user) {
                options.uid = this.user;
                var visitorID = sha1_1.hash(this.user).slice(0, 16);
                options.cid = visitorID;
            }
            // Add browser detection options
            options = Object.assign({}, options, this.browserFeatures);
            // @ts-ignore
            var trackUrl = '?' + qs.stringify(options);
            return trackUrl;
        }
        return '';
    };
    MatomoTracker.prototype.track = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (typeof navigator !== 'undefined') {
                    if (!this.initialized) {
                        return [2 /*return*/];
                    }
                    // add url to q and immediately call sendRequest()
                    this.trackQ.push(this.createRequest(options));
                    void this.sendRequests();
                }
                return [2 /*return*/];
            });
        });
    };
    MatomoTracker.prototype.trackBulk = function (options) {
        if (typeof navigator !== 'undefined') {
            if (!this.initialized) {
                return;
            }
            this.trackQ.push(this.createRequest(options));
        }
    };
    MatomoTracker.prototype.sendRequests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqUrls, regReq, submittedCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof navigator !== 'undefined')) return [3 /*break*/, 2];
                        reqUrls = this.trackQ;
                        this.trackQ = [];
                        if (!this.debug) {
                            log_1.default.info(reqUrls.toString());
                        }
                        return [4 /*yield*/, fetch(this.trackerHost, {
                                credentials: 'include',
                                method: 'POST',
                                body: JSON.stringify({ requests: reqUrls })
                            })];
                    case 1:
                        regReq = _a.sent();
                        if (regReq.status >= 300) {
                            return [2 /*return*/, null];
                        }
                        else {
                            submittedCount = reqUrls.length;
                            return [2 /*return*/, submittedCount];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MatomoTracker.prototype.makeSureThereIsAGapAfterFirstTrackingRequestToPreventMultipleVisitorCreation = function (callback) {
        if (typeof navigator !== 'undefined') {
            var now = new Date();
            var timeNow = now.getTime();
            if (this.timeNextTrackingRequestCanBeExecutedImmediately && timeNow < this.timeNextTrackingRequestCanBeExecutedImmediately) {
                // we are in the time frame shortly after the first request. we have to delay this request a bit to make sure
                // a visitor has been created meanwhile.
                var timeToWait = this.timeNextTrackingRequestCanBeExecutedImmediately - timeNow;
                setTimeout(callback, timeToWait);
                this.setExpireDateTime(timeToWait + 50); // set timeout is not necessarily executed at timeToWait so delay a bit more
                this.timeNextTrackingRequestCanBeExecutedImmediately += 50; // delay next tracking request by further 50ms to next execute them at same time
                return;
            }
            if (this.timeNextTrackingRequestCanBeExecutedImmediately === null) {
                // it is the first request, we want to execute this one directly and delay all the next one(s) within a delay.
                // All requests after this delay can be executed as usual again
                var delayInMs = 800;
                this.timeNextTrackingRequestCanBeExecutedImmediately = timeNow + delayInMs;
            }
            callback();
        }
    };
    MatomoTracker.prototype.setExpireDateTime = function (delay) {
        var now = new Date();
        var time = now.getTime() + delay;
        if (!this.expireDateTime || time > this.expireDateTime) {
            this.expireDateTime = time;
        }
    };
    /*
     * Browser features (plugins, resolution, cookies)
     *
     * Not sure how much of these are needed for Blast
     */
    MatomoTracker.prototype.detectBrowserFeatures = function () {
        if (typeof navigator !== 'undefined') {
            var browserFeatures = {};
            var i = void 0;
            var mimeType = void 0;
            var pluginMap = {
                // document types
                pdf: 'application/pdf',
                // media players
                qt: 'video/quicktime',
                realp: 'audio/x-pn-realaudio-plugin',
                wma: 'application/x-mplayer2',
                // interactive multimedia
                dir: 'application/x-director',
                fla: 'application/x-shockwave-flash',
                // RIA
                java: 'application/x-java-vm',
                gears: 'application/x-googlegears',
                ag: 'application/x-silverlight'
            };
            // detect browser features except IE < 11 (IE 11 user agent is no longer MSIE)
            if (!((new RegExp('MSIE')).test(this.navigatorAlias.userAgent))) {
                // general plugin detection
                if (this.navigatorAlias.mimeTypes && this.navigatorAlias.mimeTypes.length) {
                    for (i in pluginMap) {
                        if (Object.prototype.hasOwnProperty.call(pluginMap, i)) {
                            mimeType = this.navigatorAlias.mimeTypes[pluginMap[i]];
                            browserFeatures[i] = (mimeType && mimeType.enabledPlugin) ? '1' : '0';
                        }
                    }
                }
                // Safari and Opera
                // IE6/IE7 navigator.javaEnabled can't be aliased, so test directly
                if (typeof navigator.javaEnabled !== 'undefined' &&
                    this.isDefined(this.navigatorAlias.javaEnabled) &&
                    this.navigatorAlias.javaEnabled()) {
                    browserFeatures.java = '1';
                }
                // Firefox
                if (this.isFunction(this.windowAlias.GearsFactory)) {
                    browserFeatures.gears = '1';
                }
                // other browser features
                browserFeatures.cookie = this.hasCookies();
            }
            browserFeatures.res = this.screenAlias.width.toString() + "x" + this.screenAlias.height.toString();
            return browserFeatures;
        }
        return {};
    };
    /**
     * Cookie functions I don't think are used for anything, could be removed completely
     */
    MatomoTracker.prototype.hasCookies = function () {
        if (typeof navigator !== 'undefined') {
            if (this.cookiesDisabled) {
                return '0';
            }
            if (!this.isDefined(this.navigatorAlias.cookieEnabled)) {
                var testCookieName = this.getCookieName('testcookie');
                this.setCookie(testCookieName, '1');
                return this.getCookie(testCookieName) === '1' ? '1' : '0';
            }
            return this.navigatorAlias.cookieEnabled ? '1' : '0';
        }
    };
    /*
     * Set cookie value
     */
    MatomoTracker.prototype.setCookie = function (cookieName, value, msToExpire, path, domain, secure) {
        if (typeof navigator !== 'undefined') {
            if (this.cookiesDisabled) {
                return;
            }
            var expiryDate = new Date();
            // relative time to expire in milliseconds
            if (msToExpire) {
                expiryDate.setTime(expiryDate.getTime() + msToExpire);
            }
            this.documentAlias.cookie = cookieName + "=" + this.encodeWrapper(value) +
                (msToExpire ? ';expires=' + expiryDate.toUTCString() : '') +
                ';path=' + (path || '/') +
                (domain ? ';domain=' + domain : '') +
                (secure ? ';secure' : '');
        }
    };
    /*
     * Get cookie value
     */
    MatomoTracker.prototype.getCookie = function (cookieName) {
        if (typeof navigator !== 'undefined') {
            if (this.cookiesDisabled) {
                return 0;
            }
            var cookiePattern = new RegExp('(^|;)[ ]*' + cookieName + '=([^;]*)');
            var cookieMatch = cookiePattern.exec(this.documentAlias.cookie);
            return cookieMatch ? this.decodeWrapper(cookieMatch[2]) : 0;
        }
    };
    /*
     * Get cookie name with prefix and domain hash
     */
    MatomoTracker.prototype.getCookieName = function (baseName) {
        // NOTE: If the cookie name is changed, we must also update the PiwikTracker.php which
        // will attempt to discover first party cookies. eg. See the PHP Client method getVisitorId()
        return "" + this.configCookieNamePrefix + baseName + "." + this.siteId + "." + this.domainHash;
    };
    /*
     * Is property defined?
     */
    MatomoTracker.prototype.isDefined = function (property) {
        // workaround https://github.com/douglascrockford/JSLint/commit/24f63ada2f9d7ad65afc90e6d949f631935c2480
        var propertyType = typeof property;
        return propertyType !== 'undefined';
    };
    /*
     * Is property a function?
     */
    MatomoTracker.prototype.isFunction = function (property) {
        return typeof property === 'function';
    };
    return MatomoTracker;
}());
exports.MatomoTracker = MatomoTracker;
